import { ActivePastCampaignDto } from "../../../../../app/model/api/types/dto";

export const getActionConfig = (
  campaign: ActivePastCampaignDto,
  activeCampaigns?: boolean
): { label: string; show: boolean } | null => {
  if (campaign.hasResponded) {
    if (campaign.isWillingToContribute)
      return { label: "View Summary", show: true };
    return { label: "Edit Pledge", show: true };
  }
  if (activeCampaigns) return { label: "Pledge", show: true };
  return null;
};
